<div class="page-container" [class.loading]="isLoading || !settingsRoleMenuService.areDependenciesLoaded">
    <app-header
        [title]="roleName"
        [back]="true"
        backRoute="/settings/roles"
        [contextMenu]="true"
        [menuService]="settingsRoleMenuService"
    >
        <a (click)="onDelete()" class="item" [class.disabled]="role.roleAssignments?.length || role.isImmutable">
            {{ 'settings.role.deleteButton' | translate }}
        </a>
        <div class="buttons">
            <ui-button type="primary" *ngIf="!role.isImmutable" [routerLink]="['permissions']">
                {{ 'settings.role.editPermissionsButton' | translate }}
            </ui-button>
            <ui-button type="primary" *ngIf="role.isImmutable" [routerLink]="['permissions']">
                {{ 'settings.role.viewPermissionsButton' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-kyc-kyb-role-warning [role]="role" />

    <ui-card class="profile-card" role="group" aria-labelledby="role-details-header" [withMargin]="false">
        <div class="profile-card-header">
            <h2 id="role-details-header">{{ 'settings.role.roleDetailsHeader' | translate }}</h2>
            @if (!role.isImmutable) {
                <ui-button type="link" (click)="isEditRoleDialogOpen = true">{{ 'edit' | translate }}</ui-button>
            }
        </div>

        <label>{{ 'settings.role.nameLabel' | translate }}</label>
        <div>
            {{ roleName | translate }}
        </div>
        <label>{{ 'settings.role.descriptionLabel' | translate }}</label>
        <div>
            {{ roleDescription | translate }}
        </div>
    </ui-card>
</div>

<ui-dialog
    [open]="isEditRoleDialogOpen"
    (closing)="isEditRoleDialogOpen = false"
    (primaryButtonPressed)="submitForm(roleForm)"
    (secondaryButtonPressed)="isEditRoleDialogOpen = false"
    header="settings.role.editRoleDialogHeader"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
>
    <app-settings-role-form #roleForm [role]="role"></app-settings-role-form>
</ui-dialog>

<ui-confirmation-dialog
    #confirmDeleteDialog
    primaryButtonType="danger"
    primaryButtonLabel="settings.role.confirmDeleteDialogHeader"
    secondaryButtonLabel="cancel"
    header="components.deprecated-confirmation-dialog.header"
>
    {{ 'components.deprecated-confirmation-dialog.description' | translate }}
</ui-confirmation-dialog>
